import { Header } from "@layouts/Header";
import { HeroBadge } from "@components/ui";
import arrowIcon from "@assets/images/Frame-9.svg";

interface HeroSectionProps {
  title: string;
  description: string;
  heroImage: string;
  cta?: React.ReactNode;
  badge?: React.ReactNode;
  badgeIcon?: React.ReactNode;
  heroImageClassName?: string;
}

export function HeroSection({
  title,
  description,
  heroImage,
  cta,
  badge,
  badgeIcon,
  heroImageClassName,
}: HeroSectionProps) {
  return (
    <section className="w-full bg-[#f24d2b] relative overflow-hidden">
      {/* Container */}
      <div className="w-full max-w-[1728px] mx-auto flex flex-col items-start pt-8 px-5 md:px-10 lg:px-[121px] pb-12 relative gap-8 lg:gap-[145px]">
        {/* Header */}
        <div className="w-full relative z-10">
          <Header />
        </div>

        {/* Hero Content */}
        <div className="w-full max-w-[691px] flex flex-col items-start p-2.5 gap-10 lg:gap-[120px] z-[3]">
          {/* Main Content */}
          <div className="w-full flex flex-col items-start gap-10 lg:gap-16">
            {/* Title and Description */}
            <div className="w-full flex flex-col items-start gap-6">
              <h1 className="text-[35px] md:text-[56px] lg:text-[76px] font-bold tracking-[-0.04em] text-white leading-[1.1]">
                {title}
              </h1>
              <p className="text-xs md:text-base lg:text-[24px] tracking-[-0.04em] text-white/75 leading-[1.4]">
                {description}
              </p>
            </div>

            {/* CTA Area */}
            {cta || (
              <div className="w-full max-w-[497px] flex flex-col sm:flex-row items-stretch sm:items-center gap-4">
                {/* Input */}
                <div className="flex-1 relative">
                  <input
                    type="text"
                    placeholder="Id Number / Email"
                    className="w-full h-12 lg:h-[70px] rounded-[40px] bg-[#f9f9fb] border border-[#8b8d98] px-6 text-[16px] lg:text-[18px] font-light italic text-[#62636c] font-albert-sans outline-none focus:border-[#f24d2b] transition-colors"
                  />
                </div>

                {/* Quick Pay Button */}
                <button className="flex items-center justify-center gap-2.5 py-3 pl-4 pr-2 bg-[#292924] rounded-[40px] text-xs md:text-base lg:text-[24px] tracking-[-0.04em] text-white font-albert-sans hover:bg-[#1c1c1c] transition-colors">
                  <span>Quick Pay</span>
                  <img
                    src={arrowIcon}
                    alt=""
                    className="w-[29px] h-[29px] rounded-full"
                  />
                </button>
              </div>
            )}
          </div>

          {/* Badge Area */}
          {badge || (
            <HeroBadge
              icon={badgeIcon}
              text="Supported by real-time billing, 24/7 emergency response, and secure."
            />
          )}
        </div>

        {/* Hero Image - Desktop */}
        <img
          src={heroImage}
          alt=""
          className={
            heroImageClassName ||
            "hidden lg:block absolute top-[228px] right-0 lg:left-[869px] w-[677.7px] h-auto max-h-[1368px] z-[4]"
          }
        />
      </div>
    </section>
  );
}
